"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var AnimatedView = /*#__PURE__*/function (_React$Component) {
  _inherits(AnimatedView, _React$Component);

  function AnimatedView(props) {
    var _this;

    _classCallCheck(this, AnimatedView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnimatedView).call(this, props));
    _this.container = _react.default.createRef();
    _this.spacer = _react.default.createRef();
    _this.state = {
      activeIndex: props.activeIndex,
      stack: [props.activeIndex],
      animationStates: Array.from(Array(props.children.length), function (i) {
        return '';
      }),
      viewHeight: 0
    };
    return _this;
  }

  _createClass(AnimatedView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.spacer.current.style.width = "calc(100% * ".concat(this.spacer.current.children.length);
      Array.from(this.spacer.current.children).forEach(function (child) {
        child.style.width = 100 / _this2.spacer.current.children.length + '%';
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var children = _react.default.Children.map(this.props.children, function (child, i) {
        var classes = (0, _classnames.default)('animated-view', _this3.state.animationStates[i], {
          active: i === _this3.props.activeIndex
        });
        return _react.default.createElement("div", {
          className: classes
        }, _react.default.cloneElement(child, {
          animatedview: {
            index: i,
            activeIndex: _this3.state.activeIndex
          }
        }));
      });

      var containerClass = (0, _classnames.default)('animated-view-container', this.props.className || '');
      return _react.default.createElement("div", {
        className: containerClass,
        ref: this.container,
        style: this.props.style
      }, _react.default.createElement("div", {
        className: "animated-view-spacer",
        ref: this.spacer,
        style: {
          marginLeft: "calc(".concat(this.props.activeIndex, " * -100%)"),
          padding: this.props.padding
        }
      }, children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.activeIndex !== prevState.activeIndex) {
        var newState = {};
        var nextIndex = nextProps.activeIndex;
        var prevIndex = prevState.activeIndex;

        var animationStates = _toConsumableArray(prevState.animationStates).map(function (i) {
          return '';
        });

        var stack = prevState.stack;
        stack.push(nextIndex);
        stack.shift();
        newState.stack = stack;

        if (prevIndex > nextIndex) {
          // backward
          animationStates[prevIndex] = 'ctr';
          animationStates[nextIndex] = 'ltc';
        } else if (prevIndex < nextIndex) {
          // forward
          animationStates[prevIndex] = 'ctl';
          animationStates[nextIndex] = 'rtc';
        } else {
          animationStates[prevIndex] = '';
          animationStates[nextIndex] = '';
        }

        newState.activeIndex = nextIndex;
        newState.animationStates = animationStates;
        return newState;
      }

      return null;
    }
  }]);

  return AnimatedView;
}(_react.default.Component);

AnimatedView.propTypes = {
  style: _propTypes.default.object,
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  activeIndex: _propTypes.default.number,
  padding: _propTypes.default.string
};
AnimatedView.defaultProps = {
  style: {},
  activeIndex: 0,
  timeout: 0,
  padding: '0'
};
var _default = AnimatedView;
exports.default = _default;